import { classNames } from "@/react/helpers/twMergeWithCN";
import { useChecklistStore } from "@/react/stores/useChecklistStore";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import type { Section } from "../types";
import { SectionStep } from "./SectionStep";

interface CheckListSectionProps {
  section: Section;
}

export const CheckListSection = ({ section }: CheckListSectionProps) => {
  const { toggleSectionExpansion } = useChecklistStore();

  const handleToggleExpansion = () => {
    const sectionForToggle = {
      title: section.title,
      steps: section.steps || [],
    };
    toggleSectionExpansion(section.title, [sectionForToggle]);
  };

  return (
    <div className="border-primary border-b px-4 py-5 last:border-none">
      <button
        type="button"
        className="flex w-full cursor-pointer items-center justify-between px-4"
        onClick={handleToggleExpansion}
      >
        <Typography.TitleMd
          weight="font-semibold"
          size="text-xl"
          textTransform={section.shouldStrikeTitle ? "line-through" : "none"}
          color={section.shouldStrikeTitle ? "text-light" : ""}
        >
          {section.title}
        </Typography.TitleMd>
        <Icon
          type={section.expanded ? "cheveron-up" : "cheveron-down"}
          size={24}
        />
      </button>
      <div
        className={classNames(
          "overflow-hidden transition-all duration-300 ease-in-out",
          section.expanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0",
        )}
      >
        <div className="py-2">
          {section.steps?.map(step => (
            <SectionStep key={step.key} step={step} />
          ))}
        </div>
      </div>
    </div>
  );
};
